enum Storage {
	LOCAL_STORAGE = 'LOCAL_STORAGE',
	SESSION_STORAGE = 'SESSION_STORAGE'
}

export default Storage;
